export const REFERRAL_CONTACT_TYPE = {
  EXISTING: 'existing',
  NON_EXISTING: 'nonMyCRM',
};
